<!-- 
Created on April 28  2024
 叉车收藏
@author: xiaolong.li
  -->
<template>
  <div>
    <div
      style="
        height: 146px;
        background: #047bd0;
        padding: 20px;
        text-align: center;
      "
    >
      <h1 style="--bs-text-opacity: 1; text-transform: uppercase !important">
        <span style="color: #ffffff; font-size: 32px">{{
          $t("compare.对比装卸车")
        }}</span>
      </h1>
    </div>
    <div style="display: flex">
      <div
        style="padding: 50px; width: 500px; padding-left: 100px; display: flex"
      >
        <div style="padding-left: 50px; cursor: pointer">
          <div
            class="image-filter"
            style="
              justify-content: center;
              align-items: center;
              cursor: pointer;
            "
          >
            <img
              width="32px"
              class="image"
              height="32px"
              src="@/assets/down.png"
            />
          </div>
          <div class="favourFont" style="width: 150px">
            {{ $t("compare.导出PDF") }}
          </div>
        </div>
        <div style="padding-left: 80px">
          <a-popconfirm
            title="是否全部删除"
            cancel-text="取消"
            ok-text="确定"
            @confirm="() => delAll()"
          >
            <div
              class="image-filter"
              style="
                justify-content: center;
                align-items: center;
                cursor: pointer;
              "
            >
              <img
                width="32px"
                class="image"
                height="32px"
                src="@/assets/del.png"
              />
            </div>
            <div class="favourFont" style="width: 150px; margin-left: 2px">
              {{ $t("compare.全部删除") }}
            </div>
          </a-popconfirm>
        </div>
      </div>
      <div style="flex: 1; text-align: right; padding: 50px">
        <a-button
          size="small"
          style="
            background-color: #047bd0;
            height: 40px;
            margin-right: 50px;
            font-size: 18px;
            color: white;
          "
          @click="clickQuotation('bijiao')"
        >
          {{ $t("compare.询价所有装卸车") }}
        </a-button>
      </div>
    </div>
    <div>
      <div style="padding-left: 60px; min-width: 320px; margin: 10px 20px">
        <table
          v-if="$store.state.bijiaoList.length > 0"
          class="table table-striped table-layout-fixed"
        >
          <tbody>
            <tr>
              <!-- src="https://www.chuf.com/?img-webp=fotoch/49803/49803-01.jpg&webp-width=500" -->
              <th></th>
              <th
                v-for="(item, index) in $store.state.bijiaoList"
                :key="index"
                style="align-items: center"
              >
                <div class="image-container">
                  <img
                    width="100%"
                    height="230px"
                    style="
                      max-height: 230px;
                      min-height: 180px;
                      object-fit: cover;
                    "
                    :src="item.pic ? item.pic : require('./img/wtupian.png')"
                  />
                </div>
                <!-- <img
                  style="object-fit: cover"
                  class="responsive-image"
                  :src="item.pic ? item.pic : require('./img/wtupian.png')"
                /> -->
              </th>
            </tr>
            <tr>
              <td></td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                <a-button type="danger" ghost @click="remove(index)">
                  {{ $t("compare.删除") }}
                </a-button>
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.生产商 型号") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{ item.code }} {{ item.model }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.价格") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                0 ¥
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.负载能力 公斤") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{ item.载重能力 }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.升降 毫米") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{
                  parseInt(item.货叉最大升高) - parseInt(item.叉车回落高度)
                }}mm
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.叉车回落高度 毫米") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{ item.叉车回落高度 }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.动力方式") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{ item.动力方式 }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.阀路") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{ item.阀路 }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.电池情况") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{ item.电池情况 }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.生产年份") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{ item.factoryDate }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.工作小时数") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{ item.购入时工时 }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.叉车自重") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{ item.叉车自重 }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.属具类型") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{ item.属具类型 }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.门架类型") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                {{ item.门架类型 }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("compare.查询") }}</td>
              <td v-for="(item, index) in $store.state.bijiaoList" :key="index">
                <a-button
                  size="small"
                  style="
                    background-color: #047bd0;
                    height: 40px;
                    width: 80%;
                    font-size: 18px;
                    color: white;
                  "
                  @click="clickQuotation('fork', item)"
                >
                  {{ $t("compare.询价") }}
                </a-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div style="display: flex">
      <div
        style="padding: 50px; width: 500px; padding-left: 100px; display: flex"
      >
        <div style="padding-left: 50px; cursor: pointer">
          <div
            class="image-filter"
            style="justify-content: center; align-items: center; cursor: hand"
          >
            <img
              width="32px"
              class="image"
              height="32px"
              src="@/assets/down.png"
            />
          </div>
          <div class="favourFont" style="width: 150px">
            {{ $t("compare.导出PDF") }}
          </div>
        </div>
        <div style="padding-left: 80px">
          <a-popconfirm
            title="是否全部删除"
            cancel-text="取消"
            ok-text="确定"
            @confirm="() => delAll()"
          >
            <div
              class="image-filter"
              style="justify-content: center; align-items: center; cursor: hand"
            >
              <img
                width="32px"
                class="image"
                height="32px"
                src="@/assets/del.png"
              />
            </div>
            <div class="favourFont" style="width: 150px; margin-left: 2px">
              {{ $t("compare.全部删除") }}
            </div>
          </a-popconfirm>
        </div>
      </div>
      <div style="flex: 1; text-align: right; padding: 50px">
        <a-button
          size="small"
          style="
            background-color: #047bd0;
            height: 40px;
            margin-right: 50px;
            font-size: 18px;
            color: white;
          "
          @click="clickQuotation('bijiao')"
        >
          {{ $t("compare.询价所有装卸车") }}
        </a-button>
      </div>
    </div>
    <quotationDlg ref="quotationDlg"></quotationDlg>
  </div>
</template>

<script>
import quotationDlg from "./../project/model/quotation";
export default {
  components: { quotationDlg },
  data() {
    return {
      pics: [
        {
          comPic:
            "https://www.chuf.com/?img-webp=fotoch/49803/49803-01.jpg&webp-width=500",
        },
        {
          comPic:
            "https://www.chuf.com/?img-webp=fotoch/49803/49803-01.jpg&webp-width=500",
        },
        {
          comPic:
            "https://www.chuf.com/?img-webp=fotoch/49803/49803-01.jpg&webp-width=500",
        },
        {
          comPic:
            "https://www.chuf.com/?img-webp=fotoch/49803/49803-01.jpg&webp-width=500",
        },
        {
          comPic:
            "https://www.chuf.com/?img-webp=fotoch/49803/49803-01.jpg&webp-width=500",
        },
      ],
    };
  },
  methods: {
    delAll() {
      if (this.$store.state.bijiaoList.length > 0) {
        this.$store.dispatch("setbijiaoMessage", []);
        localStorage.setItem("bijiaoJson", {});
      } else {
        this.$notification.error({
          message: "较藏",
          description: "没有加入比较得叉车!",
        });
      }
    },
    clickQuotation(type, record) {
      //if (Object.keys(this.$store.state.userInfo).length > 0) {
      if (this.$store.state.bijiaoList.length > 0) {
        this.$refs.quotationDlg.show({ type: type, record });
      } else {
        this.$notification.error({
          message: "较藏",
          description: "没有加入比较得叉车!",
        });
      }
      // } else {
      //   this.login();
      // }
    },
    remove(index) {
      let arr = [];
      arr = this.$store.state.bijiaoList;
      arr.splice(index, 1);
      this.$store.dispatch("setbijiaoMessage", arr);
      localStorage.setItem("bijiaoJson", JSON.stringify(arr));
    },
  },
};
</script>
<style scoped>
.image-container {
  position: relative; /* 相对定位，使内部absolute定位的元素相对于此容器定位 */
  display: inline-block; /* 使div像inline-element一样表现，便于内部元素的定位 */
  width: 100%;
}
.image-container img {
  display: block; /* 防止图片下方出现空隙 */
  width: 100%; /* 或其他宽度 */
}
table tr:nth-child(odd) td:first-child {
  background-color: #e6e6e6; /* 偶数行的第一列背景色 */
  text-align: right;
  font-weight: bold;
}

table tr:nth-child(even) td:first-child {
  background-color: #f2f2f2; /* 奇数行的第一列背景色 */
  text-align: right;
  font-weight: bold;
}
/*除第一列外基偶行设置颜色 */
.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(
    --bs-table-color-state,
    var(--bs-table-color-type, var(--bs-table-color))
  );
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px
    var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}
tbody,
td,
tfoot,
th,
thead,
tr {
  border-color: inherit;
  /* border-style: solid; */
  border-width: 0;
}
td {
  text-align: center;
}
*,
::after,
::before {
  box-sizing: border-box;
}
th {
  display: table-cell;
  vertical-align: inherit;
  font-weight: bold;
  text-align: -internal-center;
  unicode-bidi: isolate;
}
.table-layout-fixed {
  table-layout: fixed;
}
/* table {
  width: 100%;
  border-collapse: collapse;
}
  */
table tr:nth-child(odd) {
  background-color: #f2f2f2;
}

table tr:nth-child(even) {
  background-color: #ffffff;
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

.favourFont {
  font-weight: 700 !important;
  text-align: left !important;
  color: #047bd0;
}
.image {
  border-radius: 50%;
  margin-left: 1px;
  margin-top: 5px;
}
.image-filter {
  display: flex;
  background-color: #047bd0;
  border-color: transparent;
  border-radius: 50%;
  width: 62px;
  height: 65px;
}
</style>
